import { Typography } from "@mui/material";
import * as DecisionBaseModal from "components/pages/game/decision-modals/DecisionBaseModal";
import React from "react";

export interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const Component: React.FC<Props> = ({ isOpen, onClose }) => {
  const renderContent = () => {
    return (
      <div>
        <Typography variant="body1">
          Are you sure you want to <strong>mulligan your cards</strong>?
        </Typography>
        <Typography variant="body1" component="em">
          You will discard all of your cards and draw 2 fewer than you previously had.
        </Typography>
      </div>
    );
  };

  return (
    <DecisionBaseModal.Component
      content={renderContent()}
      isOpen={isOpen}
      onClose={onClose}
      ActionData={{}}
      ActionId="MULLIGAN_CARDS"
      DecisionId="STARTING_HAND"
    />
  );
};

Component.displayName = "MulliganCardsModal";
